import HandshqApp from '../handshq-app';

HandshqApp.jsErrors = {
  setup() {
    const _this = this;

    this.container = $('.js__errors');
    this.close = $('.js__errors-close');
    this.list = $('.js__errors ul');

    _this.close.on('click', (event) => {
      _this.hideErrors();

      event.stopPropagation();
    });
  },

  displayErrors(errors) {
    const _this = this;

    _this.list.empty();
    errors.forEach((error) => {
      _this.list.append('<li>' + error + '</li>');
    });
    _this.container.show();
  },

  hideErrors() {
    const _this = this;

    _this.container.hide();
    _this.list.empty();
  },
};

$(() => {
  if ($('.js__errors').length) {
    HandshqApp.jsErrors.setup();
  }
});
